import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import UserContext from 'contexts/UserContext'
import { userLatsTransfers } from '../requests/transfer'
import HistoryTable from './historyContainer/historyTable'
import HomeBlockLinks from './homeContainers/homeBlockLinks'
import ContainerHome from './containerHome/containerHome'
import { Spinner } from 'utils/loading'
import ImageHomeContainer from './homeContainers/imageHomeContainer'

import iconHomePage from '../assets/iconHomePage.svg'

import classNames from 'classnames'
import RightDash from 'components/RightDash'

import { useTranslation } from 'react-i18next'
import { updateLanguage } from 'requests/user'


const Home: React.FC = () => {
  const { i18n} = useTranslation()
  

  const [loading, setLoading] = useState(false)
  const { user } = useContext(UserContext)
  const [transactionData, setTransactionData] = useState<any>([])
  const [isDataTransactionVide, setIsDataTransactionVide] = useState(false)

  const id = user?.user?._id
  const token = user?.token?.accessToken
  const languageCode = i18n.resolvedLanguage

  useEffect(() => {
    async function fetchData() {
     try {
        const response = await userLatsTransfers(id, token)
        if (response?.success === true) {
          setTransactionData(response?.transfers)
          setIsDataTransactionVide(response?.transfers.length === 0)
          setLoading(true)
        }
      } catch (error) {
        console.error(error)
      }
    }
    if (user) {
      fetchData()
    }
  }, [user])

  useEffect(() =>{
    
      if(!token || !languageCode) return
      const updateUserLanguage= async()=>{
      try{
        await updateLanguage(id, token,languageCode)
      }catch(error){
        console.log('Erreur lors de la mise à jour de la langue', error)
      }
    }
  
  updateUserLanguage()
  },[languageCode])

 
  if (!loading) return <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />

  return (
    <div className="space-y-10 mb-8">
      <div className="hidden lg:block py-5">
      <RightDash />
      </div>
      <ImageHomeContainer />
      <HomeBlockLinks />

      <div className="hidden lg:block">
        <ContainerHome />
      </div>

      <div>
        <div className="flex items-center justify-between pt-12 pb-8 sm:pb-5 lg:pt-0">
          <div className="text-[21px] sm:text-[18px] text-[#0A0A0A] font-bold">Mes Transactions</div>
          <Link
            className={classNames(` ${isDataTransactionVide ? 'hidden' : 'text-[#B4B4B4] text-[16px] font-normal'}`)}
            to={'/history'}
          > 
            Voir tout 
          </Link>
        </div>
        {isDataTransactionVide ? (
          <div className=" mt-2 mb-16 gap-6 flex flex-col items-center justify-center mx-auto border-dotted border-2 border-[#5754E5] rounded-lg w-full h-[165px]">
            <img src={iconHomePage} width={40} height={45} />
            <h2 className="text-center w-[350px] text-[#6B6B6B] place-content-center">
              Aucun transfert n&apos;a été effectué jusqu&apos;à présent. Commencez maintenant !
            </h2>
          </div>
        ) : (
          <HistoryTable isCodeVisible={false} transactionData={transactionData.slice(0, 4)} />
        )}
      </div>
      
    </div>
  )
}
export default Home
